import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type {
  IVerifyOtpApiEnvelope,
  IVerifyOtpApiPayload,
  IVerifyOtpApiResponse,
} from '../types/PhoneVerification.api';

export const verifyOtp = async (
  payload: IVerifyOtpApiPayload,
): Promise<IVerifyOtpApiResponse> => {
  const headers = await getAuthHeaders();
  const { data: envelope } = await tempMeeApi.post<IVerifyOtpApiEnvelope>(
    '/auth-service/otp/verification',
    payload,
    { headers },
  );
  return envelope.data;
};
